var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.09 21.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.24,8.04C19.24,3.37,14.67,0,9.62,0S0,3.39,0,8.04c0,1.65,.59,3.26,1.64,4.52,.05,1.47-.82,3.58-1.6,5.11,2.09-.38,5.05-1.21,6.4-2.04,7.41,1.81,12.8-2.73,12.8-7.59Zm-13.95,1.33c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2,1.2,.54,1.2,1.2-.54,1.2-1.2,1.2Zm4.33,0c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2,1.2,.54,1.2,1.2-.54,1.2-1.2,1.2Zm4.33,0c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2,1.2,.54,1.2,1.2-.54,1.2-1.2,1.2Zm8.07,8.46c-.03,.96,.54,2.34,1.05,3.35-1.37-.25-3.31-.79-4.19-1.33-3.24,.79-5.88-.28-7.29-2.02,4.38-.64,7.93-3.42,9.13-7.06,1.42,.94,2.37,2.4,2.37,4.11,0,1.08-.39,2.14-1.07,2.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.81300b465a9fbbb6226cfc0249b48fc6.svg";
export { ForwardRef as ReactComponent };